<template>
  <div>
    <div class="addreport">
      <div class="addreport__step">
        <span class="l_title">Выберите формат отчета:</span>
        <div class="addreport__wrap">
          <label>
            <input class="uk-radio" type="radio" v-model="format" value="text">
            <span>Текстовый</span>
          </label>
          <label>
            <input class="uk-radio" type="radio" v-model="format" value="audio">
            <span>Аудио</span>
          </label>
          <label>
            <input class="uk-radio" type="radio" v-model="format" value="meeting">
            <span>ОС получена уроке</span>
          </label>
          <label>
            <input class="uk-radio" type="radio" v-model="format" value="missed">
            <span>Отсутствовал на занятии</span>
          </label>
        </div>
        <label v-if="!atClass">
          <span class="l_title">Выберите даты</span>
          <input id="r_dates" type="text" class="uk-input stats__inp" placeholder="Дата" autocomplete="off" />
        </label>
        <label v-if="format === 'text'">
          <ckeditor class="ckeditor" v-model="desc" :config="editorConfig" type="inline"></ckeditor>
          <!--<textarea rows="5" placeholder="Текст отчета" class="uk-textarea" v-model="desc"></textarea>-->
        </label>
        <div class="addreport__audio" v-show="format === 'audio'">
          <div class="addreport__timer" v-if="timer > 0">
            {{ timer }}
            <small>Время записи, секунд</small>
          </div>
          <button id="mic" class="mic">Начать запись</button>
          <!--<ul id="playlist"></ul>-->
          <audio class="audio" id="voice" :src="voice_url" controls v-show="voice_url"></audio>
        </div>
        <div class="addreport__button">
          <button type="button" class="header-menu__btn" @click="warningReport">
            <i class="far fa-save"></i>
            Сохранить отчет для родителей
          </button>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MicRecorder from 'mic-recorder-to-mp3'
import CKEditor from 'ckeditor4-vue';
import swal from "sweetalert";
import moment from 'moment'

export default {
  name: "add-report",
  components: {
    ckeditor: CKEditor.component
  },
  inject: ['http'],
  data() {
    return {
      format: 'text',
      editorConfig: {},
      desc: '',
      date: '',
      voice: '',
      voice_url: '',
      timer: -1
    }
  },
  props: {
    items: '',
    atClass: {
      default: false
    },
    student_id: {
      default: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    /** Инициализируем датепикер */
    initDatepicker() {
      let app = this;
      let datepicker = $('#r_dates').datepicker({
        multipleDates: false,
        dateFormat: "dd-mm-yyyy",
        //minDate: new Date(),
        onSelect(formattedDate, date, inst) {
          app.date = formattedDate;
        }
      })
    },
    /* New recorder */
    initAudio() {
      let app = this;
      let timer;
      const button = document.querySelector('.mic');
      const recorder = new MicRecorder({
        bitRate: 64
      });

      button.addEventListener('click', startRecording);

      function startRecording() {
        console.log('Старт рекординг');
        recorder.start().then(() => {
          app.timer = 0;
          timer = setInterval(() => app.timer++, 1000);
          button.textContent = 'Остановить запись';
          button.classList.toggle('active');
          button.removeEventListener('click', startRecording);
          button.addEventListener('click', stopRecording);
        }).catch((e) => {
          console.error(e);
        });
      }

      function stopRecording() {
        recorder.stop().getMp3().then(([buffer, blob]) => {
          //console.log(buffer, blob);
          clearInterval(timer);
          app.timer = -1;
          const file = new File(buffer, 'report.mp3', {
            type: blob.type,
            lastModified: Date.now()
          });
          app.voice = blob;
          let url = URL.createObjectURL(file);
          app.voice_url = url;

          button.textContent = 'Переписать';
          button.classList.toggle('active');
          button.removeEventListener('click', stopRecording);
          button.addEventListener('click', startRecording);
        }).catch((e) => {
          console.error(e);
        });
      }
    },
    warningReport() {
        swal({
          title: 'Внимание!',
          text: 'Отправить обратную связь?',
          icon: "warning",
          buttons: ['Отмена', 'Да'],
        })
        .then((choise) => {
          if (choise) {
            this.makeReport();
          } else {
            console.log('cancel');
          }
        });
    },
    async makeReport() {
      let date = this.date;
      let desc = this.desc;
      if (this.atClass) date = moment().format('DD-MM-YYYY');
      if (this.format === 'meeting') desc = 'Обратная связь получена на уроке';
      if (this.format === 'missed') desc = 'Отсутствовал на занятии';
      if (date && (desc || this.voice_url)) {
        let fd = new FormData();
        desc = desc.replace(/&nbsp;/g, ' ')
        fd.append('voice', this.voice);
        fd.append('date', date);
        fd.append('student_id', this.student_id);
        fd.append('teacher_id', this.user.id);
        fd.append('desc', desc);
        fd.append('format', this.format);

        this.http.post('onAddTeacherReport', fd).then(res => {
          let report = res.data.report;
          report.date = moment(report.date.date).format('YYYY-MM-DD HH:mm:ss');

          this.$emit('add-report', report)
        })
      } else {
        swal('Проверьте поля!', "", "warning");
      }
    },
    checkOldOS() {
      if (this.atClass) {
        this.http.post('onLoadPastOs', { 'student_id': this.student_id, 'limit': 3 })
          .then(res => {
            let past_reports = res.data
            this.$emit('loadPastReports', past_reports);
          });
      }
      
      
    }
  },
  async mounted() {
    await this.checkOldOS();
    this.initDatepicker();
    this.initAudio();
  }
}
</script>

<style lang="scss" scoped>
.addreport__wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & label {
    margin: 0;
    margin-bottom: 15px;
  }
}
.ckeditor {
  border: 1px solid #e2e2e2;
  border-radius: 8px;
}
.addreport__button {
  margin-top: 10px;
}
.l_title {
  text-align: left;
  font-size: 14px;
  margin-top: 10px;
}
</style>